/*
*###############################################################################
*Module Name                   : ExcelUploadMaster                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Friday, September 16th 2021, 09:49:55 am      #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext, useRef } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
	Card,
	Col,
	Container,
	Row,
	CardBody,
	Alert,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'

import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text, Numeric } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';


const moment = require('moment');

import DPPrintOption from 'framework/widgets/DPPrintOptions'
import { TransactionProvider, ProductListComponent, TotalAmountComponent } from './TestContext'
import AddProductComponent from './AddProductComponent';




//**End Importing required componant files */

const TestMaster = (props) => {

	let history = useHistory();


	//***For uploaded excel file's name clear */
	const fileInputRef = useRef(null);

	//*** User input related states */
	const [productCode, SetProductCode] = useState("");// Set Code
	const [menuCode, SetMenuCode] = useState("")
	//*** End User input related states */

	//*** User Activity related states*/
	const [show, setShow] = useState(false)
	const [crEnable, setCrEnable] = useState(true)
	const [AlertMsg, setAlertMsg] = useState('')
	const [AlertColor, setAlertColor] = useState('')

	const [modal_xlarge, setmodal_xlarge] = useState(false)
	const [disabled, setDisabled] = useState(false)
	const [disabledCode, setDisabledCode] = useState(false)

	const [saveEnable, setSaveEnable] = useState(true)
	const [deleteEnable, SetDeleteEnable] = useState(false)
	const [editEnable, SetEditEnable] = useState(false)
	const [Reason, setReason] = useState("Created")

	//*** End User activity related staes */

	//Alert Parameter
	const [sweetAlertShow, setsweetAlertShow] = useState(false)
	const [AlertDescription, setAlertDescription] = useState(false)
	const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
	const [ErrorMsg, setErrorMsg] = useState('')
	const [addNew, SetAddNew] = useState(true)

	//*****Menu Rights Start*/
	const [menuAccess, SetMenuAccess] = useState(false)
	const [menuCreate, SetMenuCreate] = useState(false)
	const [menuDelete, SetMenuDelete] = useState(false)
	const [menuModify, SetMenuModify] = useState(false)
	const [menuPrint, SetMenuPrint] = useState(false)
	const [menuProcess, SetMenuProcess] = useState(false)
	const [menuName, SetMenuName] = useState("")
	const [parentName, SetParentName] = useState("")

	const [LocationCode, setLocationCode] = useState("")
	const [locationName, setLocationName] = useState("")
	const [LogUserType, setLogUserType] = useState("")
	const [LogCompanyCode, setLogCompanyCode] = useState("")
	//*****Menu Rights End */

	/**********Loading Alert */
	const [loadingAlert, SetLoadingAlert] = useState(false)
	const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
	/**********End Loading Alert */

	//autocode generation related newly added code

	const [nullCode, setNullCode] = useState(false)
	const [autoCode, setAutoCode] = useState(false)

	//User Permission related usestates
	const [permissionAlertShow, setPermissionAlertShow] = useState(false)
	const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
	const [permissionReasonShow, setPermissionReasonShow] = useState(true)
	const [permissionName, setPermissionName] = useState("")
	const [permissionPassword, setPermissionPassword] = useState("")
	const [permissionNameDisable, setPermissionNameDisable] = useState(false)

	const [printoptionShow, setprintoptionShow] = useState(false)

	//Dropdown List Related UseStates
	const [optionGroup, setOptionGroup] = useState([]) 		//set dropdown options
	const [file, setFile] = useState(null); 							//set excel file for upload
	const [selectedGroup, setSelectedGroup] = useState([])	//set selected options from dropdown list
	const [selectedGroupLabels, setSelectedGroupLabels] = useState([])
	const [selectedGroupValues, setSelectedGroupValues] = useState([])


	const [valueUpload, setvalueUpload] = useState("")
	const [Excelitems, setExcelItems] = useState([]);
	const [items, setItems] = useState([]);

	var time = process.env.REACT_APP_ALERTTIMEOUT
	const ApiURL = window.Links.ApiURL
	const ReportURL = window.Links.ReportURL


	//**Permission Granted Alert usestates */
	const [editCheck, setEditCheck] = useState(false)
	const [permissionGrantedAlertShow, setPermissionGrantedAlertShow] = useState(false)
	const [permissionGrantedAlertMsg, setPermissionGrantedAlertMsg] = useState("")
	const [permissionGrantedAlertColor, setPermissionGrantedAlertColor] = useState("")

	//import from contexts
	const {
		isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
	} = useContext(Context);
	//import from contexts


	useEffect(async () => {
		const authToken = localStorage.getItem("authToken")
		var obj = JSON.parse(localStorage.getItem("authUser"))
		var LogUserType = obj[2]
		var LocationCode = obj[3]
		var LocationName = obj[4]
		var CompanyCode = obj[5]
		var menuDetail = await getMenuDetails(window.location.pathname)
		var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
		var parentname = menuDetail?.parentName
		SetParentName(parentname)
		setLocationCode(LocationCode)
		setLocationName(LocationName)
		setLogUserType(LogUserType)
		setLogCompanyCode(CompanyCode)

		var responseData = await getSelectedMasterPermissions(LogUserType, menu)

		if (!responseData.strMenuAccessRight) {
			history.push('/dashboard')
		}

		SetMenuAccess(responseData.strMenuAccessRight)
		SetMenuCreate(responseData.strMenuCreateRight)
		SetMenuDelete(responseData.strMenuDeleteRight)
		SetMenuModify(responseData.strMenuModifyRight)
		SetMenuPrint(responseData.strMenuPrintRight)
		SetMenuProcess(responseData.strMenuProcessRight)
		SetMenuName(responseData.strMenuName)
		SetMenuCode(responseData.strMenuTag)
		setPermissionReasonShow(responseData.strMenuReasonShow)

		var autoCodeRes = await fetchAutoCode(menu)

		if (autoCodeRes.nullCode == false) {
			setAutoCode(autoCodeRes.autoCode)
		} else {
			setNullCode(true)
			setAutoCode("")
		}

	}, [productCode])


	//***get dropdown list option list */
	useEffect(async () => {


	}, [])



	// AuditLog
	useEffect(async () => {

		var obj = JSON.parse(localStorage.getItem("authUser"))
		var LogUserType = obj[2]
		var LocationCode = obj[3]
		var CompanyCode = obj[5]
		var menuDetail = await getMenuDetails(window.location.pathname)
		var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

		await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log

	}, [])


	//***Read Excel Files When Uploading Records With Excel Files */
	const readExcel = (file) => {
		const promise = new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsArrayBuffer(file);

			fileReader.onload = (e) => {
				const bufferArray = e.target.result;

				const wb = XLSX.read(bufferArray, { type: "buffer" });

				const wsname = wb.SheetNames[0];

				const ws = wb.Sheets[wsname];

				const data = XLSX.utils.sheet_to_json(ws);
				setExcelItems(data);
				resolve(data);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});

		promise.then((d) => {
			setItems(d);
		});
	};



	//*** Function for Alert Displaying */
	function displayAlertMessage(color, message) {
		setAlertColor(color)
		setAlertMsg(message)
		setShow(true)

		setTimeout(() => {
			setShow(false)
		}, time)
	}



	//*** Get and Set values when user search code */
	function getData(searchData) {

	}



	//*** End useEffect */

	function tog_xlarge() {
		setmodal_xlarge(!modal_xlarge)
		removeBodyCss()
	}



	//removebodyCss function
	function removeBodyCss() {
		document.body.classList.add("no_padding")
	}



	//save button function
	const handlesave = async (e) => {



	};



	//***Clear uploaded file name */
	const clearFilename = () => {
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
	}



	//***catch uploaded excel file */
	const handleFileChange = (e) => {
		setFile(e.target.files[0]);
	};


	const handleDropdownOnChange = (e) => {

		console.log(e)
		setSelectedGroupValues(e);

		// console.log(selectedLabels);
	}




	//***create excel file according to selected dropdown option */
	const handleGenerateExcel = async () => {


	}



	//*** Get user selected row details */
	const GetSelectRow = (e, row, isSelect, rowIndex) => {
		SetProductCode(row.CC_CODE);
		getData(row.CC_CODE)
		setDisabled(true)
		setDisabledCode(true)
		setSaveEnable(false)
		setmodal_xlarge(!modal_xlarge);
		setCrEnable(true)

	}
	//*** End of getSelectedRow function */



	//edit button function    
	const handleEdit = e => {
		setDisabled(false)
		setDisabledCode(true)
		setSaveEnable(true)
		SetDeleteEnable(true)
		SetEditEnable(false)
		setEditCheck(true)
	}



	//new button function
	const handleNew = e => {
		// e.preventDefault()
		ClearItem();
		setShow(false)
		setSaveEnable(true)
		setCrEnable(false)
		setFile(null)
		setSelectedExcelOptions([])
	}



	//clear fields function    
	const ClearItem = () => {
		SetProductCode("")

		setDisabledCode(false)
		setDisabled(false)
		setShow(false)
		setCrEnable(false)
		SetAddNew(true)
		setErrorMsg('')
		SetDeleteEnable(false)
		setNullCode(false)

		setReason("Created")
		SetEditEnable(false)
		setSaveEnable(true)
		setPermissionName("")
		setPermissionPassword("")
		setPermissionNameDisable(false)

		setEditCheck(false)

	}



	//********Delete button function */
	const handleDelete = () => {
	}


	async function handlePrint(option) {
	}


	const PermissionHandle = (operation) => {

		const authToken = localStorage.getItem("authToken")
		const permissiondata = {
			strUsername: permissionName,
			strPassword: permissionPassword,
			strLocation: LocationCode,
			strMenuCode: menuCode
		}

		clearPermissionInputs()

		fetch(`${ApiURL}login/userpermission`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Authorization": `Bearer ${authToken}`
				},
				body: JSON.stringify(permissiondata)
			}
		).then(Response => {
			if (Response.status == "200") {
				Response.json()
					.then(responseData => {
						let Access = (responseData.data.strMenuAccessRight)
						let Create = (responseData.data.strMenuCreateRight)
						let Delete = (responseData.data.strMenuDeleteRight)
						let Modify = (responseData.data.strMenuModifyRight)
						let Print = (responseData.data.strMenuPrintRight)
						let Process = (responseData.data.strMenuProcessRight)

						if (operation == "Save") {
							if (Create == true) {
								handlesave()

							} else if (Modify == true) {
								handlesave()

							} else {
								if (operation == "Save" && addNew == true) {
									displayAlertMessage('danger', "This user dosen't have permission to save")

								} else {
									displayAlertMessage('danger', "This user dosen't have permission to edit")
								}
							}
						} else if (operation == "Delete") {
							if (Delete == true) {
								handleDelete()

							} else {
								displayAlertMessage('danger', "This user don't have permission to delete !")

							}
						} else if (operation == "PDF") {
							if (Print == true) {
								handlePrint("PDF")

							} else {
								displayAlertMessage('danger', "This user don't have permission to print !")
							}
						} else if (operation == "XCEL") {
							if (Print == true) {
								handlePrint("XCEL")

							} else {
							}
						}
					})

			} else if (Response.status == "400") {
				Response.json()
					.then(responseData => {
						setErrorMsg(responseData.msg)
					})
				setDisabled(false)
				setDisabledCode(false)
				clearPermissionInputs()
				displayAlertMessage('danger', "Oops something went wrong !")

			} else if (Response.status == "403") {
				setDisabled(false)
				setDisabledCode(false)
				clearPermissionInputs()
				displayAlertMessage('danger', "You have not Permission to make changes !")

			} else if (Response.status == "404") {
				Response.json()
					.then(responseData => {
						setErrorMsg(responseData.msg)
					})
				setDisabled(false)
				setDisabledCode(false)
				clearPermissionInputs()
				displayAlertMessage('danger', "Password or User Name is Invalid !")

			} else {
				ClearItem()
			}
		}).catch(error => {
			console.log(error.message)
		})
	}

	// Function for displaying Alert Messages.
	function displayAlertMessage(color, message) {
		setAlertColor(color)
		setAlertMsg(message)
		setShow(true)

		setTimeout(() => {
			setShow(false)
		}, time)
	}


	//handle permission alert
	function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
		setPermissionName(LogUserType)
		setReason(reason)
		setPermissionNameDisable(disable)
		setPermissionAlertShow(alertShow)
	}


	//Clear permission name & password
	function clearPermissionInputs() {
		setPermissionName("");
		setPermissionPassword("");
		setReason("");
	}


	//Handle Favourite Button
	const handleFavourite = async () => {
		var response = await addtoFavourite(menuCode, LogUserType);
		console.log(response)
	}


	const [arRow, setarRow] = useState([{
		id: 1,
		code: "",
		desc: "",
		rate: "",
		state: false,
		order: "",
	}])

	function handleAddRowNested() {
		const modifiedRows = [...arRow]
		modifiedRows.push({ id: modifiedRows.length + 1 })
		setarRow(modifiedRows)
	}

	function handleRemoveRow(id) {
		if (id !== 0) {
			var modifiedRows = [...arRow]
			modifiedRows = modifiedRows.filter(x => x["id"] !== id)
			setarRow(modifiedRows)
		}
	}

	const [currentPage, setCurrentPage] = useState(1)


	return (
		< React.Fragment >
			<div className="page-content">
				<MetaTags>
					<title>{menuName}</title>
				</MetaTags>
				<Container fluid={true}>
					<Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
					<DPAlert
						confirm_both={sweetAlertShow}
						title={menuName}
						description={AlertDescription}
						showCancel={true}
						btnColor={"success"}
						cancelColor={"danger"}
						onConfirm={async () => {
							setsweetAlertShow(false)
							setPermissionName(LogUserType)
							if (AlertConfirmOption == 1) {


								if (addNew == true && menuCreate == true && permissionReasonShow == false) {
									handlesave()
								} else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
									setPermissionNameDisable(true)
									setPermissionAlertShow(true)
								} else if (addNew == false && menuModify == true && permissionReasonShow == false) {
									handlesave()

								} else if (addNew == false && menuModify == true && permissionReasonShow == true) {

									setPermissionNameDisable(true)
									setPermissionAlertShow(true)
								} else {
									if (addNew == false) {

									}
									setPermissionName("")
									setPermissionReasonShow(true)
									setPermissionAlertShow(true)
								}

							} else if (AlertConfirmOption == 2) {
								handleEdit()
							} else if (AlertConfirmOption == 3) {
								history.push('/dashboard')
							} else if (AlertConfirmOption == 4) {
								handleNew()
							} else if (AlertConfirmOption == 5) {

								if (addNew == false && menuDelete == true && permissionReasonShow == false) {
									handleDelete()
								} else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
									setReason("")
									setPermissionNameDisable(true)
									setPermissionAlertShow(true)
								} else {
									setReason("")
									setPermissionName("")
									setPermissionReasonShow(true)
									setPermissionAlertShow(true)
								}
							} else if (AlertConfirmOption == 6) {

								if (menuPrint == true && permissionReasonShow == false) {
									setprintoptionShow(true)
								} else if (menuPrint == true && permissionReasonShow == true) {
									setPermissionNameDisable(true)
									setPermissionAlertShow(true)
								} else {
									setPermissionName("")
									setPermissionReasonShow(true)
									setPermissionAlertShow(true)
								}
							}

						}}
						onCancel={() => {
							setsweetAlertShow(false)
						}}
					/>

					<DPPermission
						confirm_both={permissionAlertShow}
						title={menuName}
						description={permissionAlertTitle}
						showReason={permissionReasonShow}
						nameDisable={false}//{permissionNameDisable}
						showCancel={true}
						btnColor={"success"}
						cancelColor={"danger"}
						AlName={permissionName}
						show={permissionGrantedAlertShow}
						AlertColor={permissionGrantedAlertColor}
						AlertMsg={permissionGrantedAlertMsg}
						AlNameOnchange={e => {
							let val2 = Text(e.target, 50, true, false, "any", false)
							setPermissionName(val2)
						}}
						AlPassward={permissionPassword}
						AlPasswardOnchange={e => {
							let val2 = Text(e.target, 50, true, true, "any", false)
							setPermissionPassword(val2)
						}}
						AlReason={Reason}
						AlReasonOnchange={e => {
							let val2 = Text(e.target, 50, true, false, "any", true)
							setReason(val2)
						}}
						onConfirm={() => {

							setPermissionAlertShow(false)
							if (AlertConfirmOption == 1) {
								PermissionHandle("Save")
							} else if (AlertConfirmOption == 5) {
								PermissionHandle("Delete")
							} else if (AlertConfirmOption == 6) {
								setprintoptionShow(true)
							}
						}}
						onCancel={() => {
							setPermissionAlertShow(false)
						}}
					/>
					<DPPrintOption
						confirm_both={printoptionShow}
						title={menuName}
						showCancel={true}
						cancelColor={"danger"}
						onConfirmpdf={() => {
							handlePrint("PDF")
							setprintoptionShow(false)
						}}
						onConfirmxcel={() => {
							handlePrint("XCEL")
							setprintoptionShow(false)
						}}
						onCancel={() => {
							setprintoptionShow(false)
						}}
					/>
					<DPLoadingAlert
						confirm_both={loadingAlert}
						title={loadingAlertTitle}
					/>
					<Row>
						<Col lg={12}>
							<Card>
								<CardBody>
									<DPTopToolBar
										//Help Button
										helpEnable={false}
										helpClick={() => {
											alert("Help")
										}}
										//Favorite Button
										favoriteEnable={true}
										favoriteClick={handleFavourite}
										//New Button
										newEnable={true}
										newClick={() => {
											setAlertDescription("Do you wish to refresh the screen ?");
											setAlertConfirmOption(4)
											setsweetAlertShow(true)
										}}
										//Save Button
										saveEnable={saveEnable}
										saveClick={() => {
											setAlertDescription("Do you wish to save ?");
											setAlertConfirmOption(1)
											setsweetAlertShow(true)
										}}
										//ProcessButton
										processEnable={false}
										processClick={() => {
											alert("Process")
										}}
										//Edit Button
										editEnable={editEnable && isHeadOffice}
										editClick={() => {
											setAlertDescription("Do you wish to edit ?");
											setAlertConfirmOption(2)
											setsweetAlertShow(true)
										}}
										//Print Button

										printEnable={true}
										printClick={() => {
											setReason("Printed")
											setAlertDescription("Do you wish to print ?");
											setAlertConfirmOption(6)
											setsweetAlertShow(true)
										}}
										//Delete Button
										deleteEnable={deleteEnable}
										deleteClick={() => {
											setReason("Deleted")
											setAlertDescription("Do you wish to delete ?");
											setAlertConfirmOption(5)
											setsweetAlertShow(true)
										}}
										//Exit Button
										exitEnable={true}
										exitClick={() => {
											setAlertDescription("Do you wish to exit ?");
											setAlertConfirmOption(3)
											setsweetAlertShow(true)
										}}
									/>
									{show ? (
										<Alert color={AlertColor} role="alert">
											{AlertMsg}
											<br />
											<small>{ErrorMsg}</small>
										</Alert>
									) : null}
									<Row>
										<TransactionProvider>
											<div>
												{/* Other components */}
												{/* <ProductListComponent />
												<TotalAmountComponent />
												<AddProductComponent /> */}

											</div>
										</TransactionProvider>
									</Row>

								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>

		</React.Fragment >
	)

}

export default TestMaster

